<template>
	<div class="page-mouth">
		<div class="content">
			<time-num></time-num>
			<div class="body-box" v-if="list.fileList && list.fileList.length">
				<van-swipe ref="swiper" class="my-swipe" :autoplay="3000" indicator-color="white">
					<van-swipe-item v-for="item in list.fileList" :key="item.id">
						<img @click="handleImg(item.filePath)" :src="item.filePath" alt />
					</van-swipe-item>
				</van-swipe>
				<div class="rightChanges" v-show="list.fileList.length > 1" @click="handleNextClick(true)">
					<van-icon name="arrow-left" color="#fff" size="19" />
				</div>
				<div class="rightChange" v-show="list.fileList.length > 1" @click="handleNextClick(false)">
					<van-icon name="arrow" color="#fff" size="19" />
				</div>
			</div>
			<div class="choose-box" v-if="list.optionList && list.optionList.length">
				<div class="choose-text">
					请选择符合图片情况的正确病变描述 （{{ list.typeName }}）：
				</div>
				<div class="choose-list" v-for="(item, index) in list.optionList" @click="handleChooseClick(index)"
					:key="index" :class="item.type ? 'choose-active' : ''">
					<p>{{ item.value }}</p>
					<div>{{ item.content }}</div>
				</div>
			</div>
			<div v-else class="choose-no">
				{{ list.title }},{{ list.remarks ? list.remarks : "无异常皮肤表现" }}
			</div>
		</div>

		<div class="footer">
			<div class="btn">
				<div class="return" @click="handleBack">
					<img src="./../../assets/treat/return.png" alt />
					<span>返回</span>
				</div>
				<div class="return submit" @click="handleSubmit" v-if="list.optionList && list.optionList.length">
					<img src="./../../assets/treat/submit.png" alt />
					<span>{{ commitText }}</span>
				</div>
			</div>
		</div>
		<van-popup v-model="isShow" class="dialogImg">
			<div class="imgAmplify">
				<img :src="activeImg" alt />
			</div>
		</van-popup>
		<mouthModal ref="modalRef" @ok="ok"></mouthModal>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import mouthModal from "./mouthModal.vue";
	import {
		mapState,
		mapMutations
	} from "vuex";
	import MiXin from "../mixins/index";
	import TimeNum from "../mixins/timeNum";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		components: {
			MiXin,
			mouthModal,
			TimeNum,
		},
		name: "mouth",
		data() {
			return {
				commitText: "提交",
				submitObj: {},
				list: this.$route.query.list, //当前页面数据
				clientHeightFlag: true,
				isShow: false,
				activeImg: null,
				fromPath: null,
			};
		},
		computed: {
			...mapState("visualExamination", [
				"selectPosition",
				"submitFlag",
				"selectPositionObj",
				"treatmentList",
				"mouthModalFlag",
				"treatmentEcho",
				//步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
			]),
			...mapState("microscope", ["examDetailId"]),
		},
		async mounted() {
			if (document.documentElement.clientHeight >= 1038) {
				this.clientHeightFlag = false;
			} else {
				this.clientHeightFlag = true;
			}
			await this.$nextTick();
			this.list.optionList = this.list.optionList.map((item) => {
				return {
					type: false,
					...item,
				};
			});
			document.title = "视诊-" + this.list.title;
			if (this.treatmentEcho) {
				this.treatmentEcho.map((item) => {
					this.list.optionList.map((v) => {
						if (item.id === v.id) {
							v.type = true;
							this.commitText = "已提交";
						}
					});
				});
			}
		},

		watch: {
			selectPosition: {
				handler(val) {
					this.submitObj = val;
				},
				deep: true,
			},
		},
		created() {},
		methods: {
			...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),

			//点击选题
			handleChooseClick(index) {
				if (this.commitText === "提交") {
					if (this.list.type === "2" || this.list.type === "3") {
						this.list.optionList[index].type = !this.list.optionList[index].type;
					} else {
						this.list.optionList.forEach((item) => (item.type = false));
						this.list.optionList[index].type = true;
					}
				}
			},

			//点击返回
			handleBack() {
				const obj = {
					id: this.selectPositionObj.id,
					accomplish: true,
				};
				//如果没有题按钮变亮
				if (!this.list.optionList || !this.list.optionList.length) {
					this.VISUAL_EXAMINATION({
						key: "selectPositionObj",
						value: obj
					});
					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					const parmes = {
						paperId: this.treatmentList.id,
						details: newArr,
					};
					submitExamCommitSingerAnswer({
						backendAnswers: JSON.stringify(parmes),
						paperId: JSON.stringify({
							obj: obj,
							arr: this.selectPosition
						}),
						questionId: '-2',
						answers: JSON.stringify({
							detail: this.detail,
							detailsz2: this.detailsz2,
							detail3: this.detail3,
							detailstepPre3: this.detailstepPre3,
							detail4: this.detail4,
							detail5: this.detail5,
							treatmentEcho: this.treatmentEcho
						}),
						extractDetailId: this.examDetailId,
					}).then((response) => {
						this.$router.replace({
							path: "/treat/point"
						});
					});
				} else {
					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					const parmes = {
						paperId: this.treatmentList.id,
						details: newArr,
					};
					submitExamCommitSingerAnswer({
						backendAnswers: JSON.stringify(parmes),
						paperId: JSON.stringify(this.selectPosition),
						questionId: '-2010',
						answers: JSON.stringify({
							detail: this.detail,
							detailsz2: this.detailsz2,
							detail3: this.detail3,
							detailstepPre3: this.detailstepPre3,
							detail4: this.detail4,
							detail5: this.detail5,
							treatmentEcho: this.treatmentEcho
						}),
						extractDetailId: this.examDetailId,
					}).then((response) => {
						this.$router.replace({
							path: "/treat/point"
						});
					});
				}
			},

			//点击确定
			handleSubmit() {
				if (this.commitText === "提交") {
					let num = 0;
					this.list.optionList.forEach((item) => {
						if (item.type) {
							num++;
						}
					});
					if (this.list.type === "1" || this.list.type === "3") {
						if (num === 0) {
							this.$refs.modalRef.tip();
							return;
						}
					} else if (this.list.type === "2") {
						if (num <= 1) {
							this.$refs.modalRef.tip();
							return;
						}
					}
					if (this.mouthModalFlag) {
						//是否第一次显示弹窗
						this.ok();
					} else {
						this.$refs.modalRef.handleShow();
					}
				}
			},

			//子传父确定方法
			ok() {
				let idList = [];
				let list = [];
				this.list.optionList.forEach((item) => {
					if (item.type) {
						idList.push(item.value);
						this.VISUAL_EXAMINATION({
							key: "treatmentEcho",
							value: item
						});
					}
				});

				const val = idList.join(",");
				list = {
					answers: val,
					questionId: this.list.id
				};
				this.VISUAL_EXAMINATION({
					key: "detail",
					value: list
				});
				this.VISUAL_EXAMINATION({
					key: "mouthModalFlag",
					value: true
				});
				const obj = {
					id: this.selectPositionObj.id,
					accomplish: true,
				};
				this.VISUAL_EXAMINATION({
					key: "selectPositionObj",
					value: obj
				});
				let newArr = [
					...this.detail,
					...this.detailsz2,
					...this.detail3,
					...this.detailstepPre3,
					...this.detail4,
					...this.detail5,
				];
				const parmes = {
					paperId: this.treatmentList.id,
					details: newArr,
				};
				submitExamCommitSingerAnswer({
					backendAnswers: JSON.stringify(parmes),
					paperId: JSON.stringify({
						id: this.selectPositionObj.id,
						arr: this.selectPosition
					}),
					questionId: '-3',
					answers: JSON.stringify({
						detail: this.detail,
						detailsz2: this.detailsz2,
						detail3: this.detail3,
						detailstepPre3: this.detailstepPre3,
						detail4: this.detail4,
						detail5: this.detail5,
						treatmentEcho: this.treatmentEcho
					}),
					extractDetailId: this.examDetailId,
				}).then((response) => {
					this.$router.replace({
						path: "/treat/point"
					});
				});
			},

			//点击下一步
			handleNextClick(v) {
				if (v) {
					this.$refs.swiper.prev();
				} else {
					this.$refs.swiper.next();
				}
			},

			// 选中看大图
			handleImg(url) {
				this.activeImg = url;
				this.isShow = true;
			},
		},
	};
</script>

<style lang="less" scoped>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.page-mouth {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;

		::v-deep .van-swipe__indicator {
			background: #ab3b91 !important;
		}

		.content {
			flex: 1;
			width: 100%;
			padding: 0 45px 90px 45px;
			margin-bottom: 130px;

			.time-num {
				padding: 10px 0;
			}

			// padding-top: 90px;
		}

		.body-box {
			width: 100%;
			height: 545px;
			background: rgba(255, 255, 255, 0.3);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border: 2px solid #ffffff;
			padding: 19px 23px;
			border-radius: 60px;
			position: relative;

			.my-swipe,
			.van-swipe-item,
			img {
				width: 100%;
				height: 100%;
				border-radius: 48px;
			}
		}

		.rightChanges {
			width: 72px;
			height: 72px;
			opacity: 0.7;
			border-radius: 50%;
			background: #ab3b91;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 240px;
			left: 27px;
		}

		.rightChange {
			width: 72px;
			height: 72px;
			opacity: 0.7;
			border-radius: 50%;
			background: #ab3b91;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 240px;
			right: 27px;
		}

		::v-deep .van-swipe__indicator {
			width: 18px;
			height: 18px;
			background: #d2d2d2;
		}

		.choose-no {
			margin-top: 45px;
			background: rgba(255, 255, 255, 0.8);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border: 2px solid #ffffff;
			border-radius: 60px;
			padding: 40px 45px 40px 45px;
			width: 100%;
			height: 450px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 45px;
			font-family: HarmonyOS Sans SC;
			font-weight: bold;
			color: #ab3b91;
			margin-bottom: 120px;
		}

		.choose-box {
			margin-top: 45px;
			width: 100%;
			height: auto;
			background: rgba(255, 255, 255, 0.5);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border: 2px solid #ffffff;
			border-radius: 60px;
			padding: 40px 45px 40px 45px;

			.choose-text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 50px;
			}

			.choose-list {
				width: 100%;
				height: auto;
				background: #ffffff;
				box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
				border-radius: 40px;
				margin-top: 20px;
				font-size: 25px;
				font-family: HarmonyOS Sans SC;
				font-weight: 400;
				color: #4d4d4d;
				display: flex;
				align-items: center;
				padding: 28px 61px;

				p {
					position: relative;
					margin-right: 19px;
				}

				p::before {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 39px;
					content: "";
					width: 2px;
					height: 38px;
					background: #cccccc;
				}

				div {
					margin-left: 35px;
				}
			}

			.choose-active {
				box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
				background: #ab3b91;
				color: #fff;
			}

			.choose-active>p::before {
				background: #fff;
			}
		}

		.footer {
			position: fixed;
			bottom: 0;
			width: 100%;
			height: 183px;
		}

		.btnActive {
			position: absolute;
			left: 0;
			bottom: 0;
		}

		.btn {
			width: 100%;
			height: 183px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			border-radius: 60px 60px 0px 0px;

			display: flex;
			align-items: center;
			justify-content: center;

			.return {
				width: 201px;
				height: 87px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				display: flex;
				border-radius: 50px;
				align-items: center;
				justify-content: center;

				img {
					width: 36px;
					height: 33px;
				}

				span {
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					line-height: 59px;
				}

				span:nth-child(2) {
					margin-left: 25px;
				}
			}

			.submit {
				width: 310px;
				height: 87px;
				margin-left: 50px;
			}
		}

		.page-mouthModal {
			width: 100%;
			min-height: 100vh;
			position: absolute;
			left: 0;
			top: 0;
			background: rgba(#fff, 0.8);
			padding: 0 40px;
			display: flex;
			align-items: center;
			z-index: 1;

			.content {
				width: 100%;
				height: 642px;
				z-index: 999;
				background: #ffffff;
				background: rgba(255, 255, 255, 0.9);
				border: 2px solid #ffffff;
				border-radius: 60px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding-top: 90px;
				padding-bottom: 77px;
			}

			.title {
				font-size: 65px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #ab3b91;
			}

			.text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				margin-top: 80px;
				text-align: center;
			}

			.footer-modl {
				margin-top: 110px;

				button {
					width: 262px;
					height: 79px;
					background: linear-gradient(132.74deg,
							rgba(0, 187, 177, 1) 0%,
							rgba(0, 86, 140, 1) 74.31%,
							rgba(171, 59, 127, 1) 100%);
					border: 1px solid #ffffff;
					box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
					text-align: center;
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					line-height: 60px;
					letter-spacing: 2px;
					border-radius: 40px;
				}

				button:nth-child(2) {
					margin-left: 42px;
				}
			}
		}
	}

	::v-deep .van-popup {
		border-radius: 0;
		width: 100%;
		background: none;

		.imgAmplify {
			width: 92%;
			margin: 0 auto;

			img {
				width: 100%;
				max-height: 800px;
			}
		}
	}
</style>